import { type StockStatusElements } from "@jti/fe-common";
import type { MultipleFlavorsSelectorItem } from "@jti/ui/components/MultipleFlavorsSelector";
import type { SingleFlavorSelectorItem } from "@jti/ui/components/SingleFlavorSelector";

import { isVisibleByStockStatus } from "@product-details/utils/stockStatus";

export const filterOutOfStockItems = <T extends MultipleFlavorsSelectorItem | SingleFlavorSelectorItem>(
  items: T[],
  displayOutOfStockStickProducts: boolean,
  displayAvailableInStoresStickProducts: boolean,
  elementsStockStatus: StockStatusElements
): T[] =>
  items.filter((flavor) => {
    const key = "sku" in flavor ? flavor.sku : flavor.id;

    if (!Object.hasOwn(elementsStockStatus, key)) return false;

    return isVisibleByStockStatus(elementsStockStatus[key], {
      displayOutOfStock: displayOutOfStockStickProducts,
      displayAvailableInStores: displayAvailableInStoresStickProducts,
    });
  });
